import styled from 'styled-components';
import { mixins } from '@sy/component-library';
import darkBlue from './darkBlue.svg';
import blue from './blue.svg';

const { media } = mixins;

type QuoteWrapperProps = {
	background?: string;
};
export const QuoteWrapper = styled('div')<QuoteWrapperProps>`
	width: 100%;
	padding: 96px 24px;
	background-image: url(${({ background }) =>
		background === 'darkBlue' ? darkBlue : blue});
	background-size: cover;
	background-repeat: no-repeat;
`;

export const QuoteContent = styled.div`
	width: 100%;
	max-width: 1000px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const Quote = styled.span`
	font-weight: 700;
	font-size: 3.2rem;
	line-height: 4.2rem;
	text-align: center;
	color: ${({ theme }) => theme.colors.white};

	${media.belowLarge`
		font-size: 2.4rem;
		line-height: 3.2rem;
	`}

	&:before {
		content: '“';
	}

	&:after {
		content: '”';
	}
`;

export const QuoteCopy = styled.span`
	font-size: 1.8rem;
	line-height: 2.7rem;
	text-align: center;
	color: ${({ theme }) => theme.colors.white};
`;

export const QuoteAuthorAvatar = styled.div`
	width: 44px;
	min-width: 44px;
	height: 44px;
	overflow: hidden;
	margin-right: 16px;

	img {
		border-radius: 22px;
	}
`;

export const QuoteAuthorWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 6px;
`;

export const QuoteAuthorName = styled.span`
	font-weight: 600;
	font-size: 1.4rem;
	line-height: 1.6rem;
	color: ${({ theme }) => theme.colors.white};
	text-align: center;
`;

export const QuoteAuthorSeparator = styled.span`
	font-weight: 600;
	font-size: 1.4rem;
	line-height: 1.6rem;
	color: ${({ theme }) => theme.colors.white};
`;

export const QuoteAuthorJobTitle = styled.span`
	font-size: 1.3rem;
	line-height: 1.6rem;
	color: ${({ theme }) => theme.colors.white};
	text-align: center;
`;
